import { render, staticRenderFns } from "./FanCoil.vue?vue&type=template&id=ca95c27a&scoped=true&"
import script from "./FanCoil.vue?vue&type=script&lang=js&"
export * from "./FanCoil.vue?vue&type=script&lang=js&"
import style0 from "./FanCoil.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FanCoil.vue?vue&type=style&index=1&id=ca95c27a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca95c27a",
  null
  
)

export default component.exports